export default "__VITE_PUBLIC_ASSET__5dd7dc69__"